import React, {useEffect, useState} from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../../ui/Dialog/DialogActions";
import TextField from "../../../../../../../../ui/TextField";
import Grid from "@material-ui/core/Grid";
import Alert from '@material-ui/lab/Alert';

const styles = theme => ({
  dialog: {
    width: "476px"
  }
});

const initialData = {
  order: null,
  description: ""
};

const AddVariantModal = ({
                           title,
                           confirmButtonCaption,
                            open,
                            handleClose,
                            onCreate,
                            isCreating,
                            createdObject,
                           updatedObject,
                           variantData,
                            classes
                          }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [data, setData] = React.useState(initialData);

  useEffect(() => {
    if (variantData) {
      setData(variantData);
    }
  }, [variantData]);

  const onConfirm = () => {
    setErrorMessage(null);
    onCreate(data);
  };

  const onClose = () => {
    setErrorMessage(null);
    setData(initialData);
    handleClose();
  };

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
  };

  useEffect(() => {
    if (createdObject !== null && createdObject !== undefined) {
      if (createdObject.success) {
        setData(initialData);
        setErrorMessage(null);
        handleClose();
      } else if (createdObject.errors !== null && createdObject.errors.length > 0) {
        let msg = createdObject.errors.map(({message}) => message).join(", ");
        setErrorMessage(msg);
      }
    } else {
      setData(initialData);
      setErrorMessage(null);
    }
  },[createdObject])

  useEffect(() => {
    if (updatedObject !== null && updatedObject !== undefined) {
      if (updatedObject.success) {
        setData(initialData);
        setErrorMessage(null);
        handleClose();
      } else if (updatedObject.errors !== null && updatedObject.errors.length > 0) {
        let msg = updatedObject.errors.map(({message}) => message).join(", ");
        setErrorMessage(msg);
      }
    } else {
      setData(initialData);
      setErrorMessage(null);
    }
  },[updatedObject])

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>{title}</DialogTitle>
        <DialogContent>
          {data &&
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                required
                value={data.order || 0}
                onChange={e => onChange("order", e.target.value)}
                label="Номер п/п"
              />
            </Grid>
            <Grid item xs={9}>
              <TextField
                required
                value={data.description || ''}
                onChange={e => onChange("description", e.target.value)}
                label="Описание варианта"
              />
            </Grid>
          </Grid>}
          {errorMessage !== null &&
          <Alert severity="error">{errorMessage}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreating}
            disabled={isCreating || !data || !data.description}
            onClick={() => onConfirm()}
            color="green"
          >
            {confirmButtonCaption}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(AddVariantModal);
